// extracted by mini-css-extract-plugin
module.exports = {"column-teams":"column-teams","column":"column","tournament-team":"tournament-team","text":"text"};